export default __webpack_public_path__ + "static/media/stanford_logo.d5332ec1.png";